<template>
  <div class="form-row row">
    <div class="col-12 d-flex">
      <div class="mr-2">
        <input ref="dayInput" required v-model="day" type="number" min="1" max="31" maxlength="2" size="4" placeholder="DD"
               style="width: auto"
               :class="{'is-invalid': dayError}"
               class="form-control">
      </div>
      <div class="mr-2">
        <input ref="monthInput" required v-model="month" type="number" min="1" max="12" maxlength="2" size="4" placeholder="MM"
               style="width: auto"
               :class="{'is-invalid': monthError}"
               class="form-control">
      </div>
      <div class="mr-2">
        <input ref="yearInput" required v-model="year" type="number" :min="minYear"
               :max="maxYear" maxlength="4" minlength="4" size="6" placeholder="YYYY" style="width: auto"
               :class="{'is-invalid': yearError}"
               class="form-control">
      </div>
    </div>
  </div>
</template>

<script>

import {convertToSQLDate} from "@/state/helpers";

export default {
  props: ['value', 'minYear', 'maxYear', 'error'],
  data() {
    return {
      day: '',
      month: '',
      year: '',
      dayError: false,
      monthError: false,
      yearError: false
    };
  },
  created() {
    this.setYearMonthAndDay();
  },
  watch: {
    value() {
      this.setYearMonthAndDay();
      this.updateValue();
    },
    day() {
      this.updateValue();
      if (!this.dayError && this.day.toString().length === 2) {
        this.$refs.monthInput.focus();
      }
    },
    month() {
      this.updateValue();
      if (!this.monthError && this.month.toString().length === 2) {
        this.$refs.yearInput.focus();
      }
    },
    year() {
      this.updateValue();
      this.$refs.yearInput.focus()
    },
    error() {
      if (this.error) {
        this.dayError = true;
        this.monthError = true;
        this.yearError = true;
      }
    },
  },
  methods: {
    setYearMonthAndDay() {
      if (this.value) {
        const date = new Date(this.value);
        this.day = date.getDate();
        this.month = date.getMonth() + 1;
        this.year = date.getFullYear();
      }
    },
    updateValue() {
      let hasError = false;
      this.dayError = false;
      this.monthError = false;
      this.yearError = false;
      if (!this.day || this.day <= 0 || this.day > 31) {
        this.dayError = true;
        hasError = true;
      }
      if (!this.month || this.month <= 0 || this.month > 12) {
        this.monthError = true;
        hasError = true;
      }
      if (!this.year || this.year.toString().length < 4 || this.year.toString().length > 4 || this.year < this.minYear || this.year > this.maxYear) {
        this.yearError = true;
        hasError = true;
      }

      if (!hasError) {
        let month = '' + this.month,
            day = '' + this.day;

        // Fix for safari. Safari requires two digits for month and day, otherwise it cannot create new Date instance :(
        if (month.length < 2)
          month = '0' + month;
        if (day.length < 2)
          day = '0' + day;

        this.$emit('input', convertToSQLDate(`${this.year}-${month}-${day}`));
      }

    }
  }
}
</script>

<style scoped>
</style>
